/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, AuditReportsGetGipAltReportEvidenceExportUrlPathParams, AuditReportsGetGipAltReportEvidenceExportUrl401, AuditReportsGetGipAltReportEvidenceExportUrl403, AuditReportsGetGipAltReportEvidenceExportUrl404 } from "../models/AuditReportsGetGipAltReportEvidenceExportUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipAltReportEvidenceExportUrl } from "../axios/auditReportsGetGipAltReportEvidenceExportUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipAltReportEvidenceExportUrlQueryKey = (id: AuditReportsGetGipAltReportEvidenceExportUrlPathParams["id"]) => ["api-v2", { url: '/audit-reports/v1/reports/gip-alt/report/:id/evidence-export-url', params: {id:id} }] as const

export type AuditReportsGetGipAltReportEvidenceExportUrlQueryKey = ReturnType<typeof auditReportsGetGipAltReportEvidenceExportUrlQueryKey>

export function auditReportsGetGipAltReportEvidenceExportUrlQueryOptions(id: AuditReportsGetGipAltReportEvidenceExportUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipAltReportEvidenceExportUrlQueryKey(id)
        return queryOptions<AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsGetGipAltReportEvidenceExportUrl401 | AuditReportsGetGipAltReportEvidenceExportUrl403 | AuditReportsGetGipAltReportEvidenceExportUrl404>, AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipAltReportEvidenceExportUrl(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export URL for existing report
 * {@link /audit-reports/v1/reports/gip-alt/report/:id/evidence-export-url}
 */
export function useAuditReportsGetGipAltReportEvidenceExportUrl<TData = AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, TQueryData = AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipAltReportEvidenceExportUrlQueryKey>(id: AuditReportsGetGipAltReportEvidenceExportUrlPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipAltReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsGetGipAltReportEvidenceExportUrl401 | AuditReportsGetGipAltReportEvidenceExportUrl403 | AuditReportsGetGipAltReportEvidenceExportUrl404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipAltReportEvidenceExportUrlQueryKey(id)
         

         const query = useQuery({
          ...auditReportsGetGipAltReportEvidenceExportUrlQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipAltReportEvidenceExportUrl401 | AuditReportsGetGipAltReportEvidenceExportUrl403 | AuditReportsGetGipAltReportEvidenceExportUrl404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}